import workspaceQuery from '../../../graphql/queries/sales/PickingBoxWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/PickingBoxQuery.graphql';
import fragment from '../../../graphql/fragments/sales/PickingBoxFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PickingBox: EntityType = {
  type: 'PickingBox',
  title: 'Picking Boxes',
  formTitle: 'Picking Box',
  formUrl: '/Sales/Picking/PickingBox/Details/',
  workspaceUrl: '/Sales/Picking/PickingBox/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'PICKING_BOX',
};

export default PickingBox;
